import { createActionNameForProcessingFetch } from '../../utils/helpers/actionCreatorHelpers';
import { CC_EMAILS_DOMAIN_NAME } from './constants';

export const getCCEmailsConstants = createActionNameForProcessingFetch('getCCEmails', CC_EMAILS_DOMAIN_NAME);
export const updateCCEmailsConstants = createActionNameForProcessingFetch('updateCCEmails', CC_EMAILS_DOMAIN_NAME);
